/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Header_Join_EventInputs */

const en_header_join_event = /** @type {(inputs: Header_Join_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join an event`)
};

/**
* | output |
* | --- |
* | "Join an event" |
*
* @param {Header_Join_EventInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const header_join_event = /** @type {((inputs?: Header_Join_EventInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Header_Join_EventInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_header_join_event(inputs)
});